@if (imageError) {
  <div class="img-loader-container">
    <img
      ngSrc="./assets/graphic-error.svg"
      alt=""
      height="142"
      width="212" />
    <h2 class="mt-5">Oh no!</h2>
    <p class="container-380 mx-auto text-center">
      <strong>{{ errorMessage }}</strong>
    </p>
  </div>
}

@if (!imageError) {
  <div class="receipt-preview-scroll">
    <div class="receipt-preview-image-wrapper">
      <img
        [src]="url()"
        [ngStyle]="{ transform: transformStyle }"
        class="img-fluid"
        alt="Receipt preview"
        (load)="onImageLoad()"
        (error)="onImageError()" />
    </div>
  </div>
  <div class="px-3 pb-4 pt-0">
    <!-- Zoom slider -->
    <div class="pb-1">
      <input
        type="range"
        class="zoom-slider"
        [min]="MIN_ZOOM"
        [max]="MAX_ZOOM"
        [step]="ZOOM_STEP"
        [(ngModel)]="zoom"
        aria-label="Zoom slider" />
    </div>

    <div class="row justify-content-center">
      <!-- Zoom controls -->
      <div class="col-auto">
        <div class="row align-items-center">
          <div class="col-auto">
            <button
              class="btn-action"
              (click)="zoomOut()"
              [disabled]="zoom <= MIN_ZOOM"
              title="Zoom out">
              <i class="iconoir-minus-circle"></i>
            </button>
          </div>
          <div class="col-auto">{{ zoom }}%</div>
          <div class="col-auto">
            <button
              class="btn-action"
              (click)="zoomIn()"
              [disabled]="zoom >= MAX_ZOOM"
              title="Zoom in">
              <i class="iconoir-plus-circle"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Rotation controls -->
      <div class="col-auto">
        <button
          class="btn-action"
          (click)="rotateCounterClockwise()"
          title="Rotate counter-clockwise">
          <i class="pays-svg-icon ic-rotate-left"></i>
        </button>
      </div>

      <div class="col-auto">
        <button
          class="btn-action"
          (click)="rotateClockwise()"
          title="Rotate clockwise">
          <i class="pays-svg-icon ic-rotate-right"></i>
        </button>
      </div>

      <!-- Reset button -->
      <div class="col-auto">
        <button
          class="btn-action"
          (click)="resetView()"
          aria-label="Reset view">
          <i class="iconoir-refresh-double"></i>
        </button>
      </div>
    </div>
  </div>
}
